var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TikTokIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 46,
    glyphHeight: 53
  }), React.createElement("path", {
    d: "M45.7387 21.8882C42.922 21.8882 40.1054 21.2382 37.2887 20.1549C35.5554 19.5049 34.0387 18.4216 32.522 17.3382V36.4049C32.522 40.7382 30.7887 44.6382 27.7554 47.6716C25.1554 50.0549 22.122 51.7882 18.6554 52.2216C18.0054 52.4382 17.1387 52.4382 16.272 52.4382C12.5887 52.4382 9.12204 51.3549 6.30537 48.9716C5.87204 48.5382 5.22204 48.1049 4.7887 47.6716C1.5387 44.4216 -0.19463 39.8716 0.0220368 35.3216C0.238704 31.8549 1.75537 28.3882 4.13871 25.7882C7.17204 22.3216 11.722 20.3716 16.272 20.3716C17.1387 20.3716 18.0054 20.3716 18.6554 20.5882V29.2549C18.0054 28.8216 17.1387 28.6049 16.272 28.6049C11.9387 28.6049 8.47204 32.0716 8.6887 36.4049C8.6887 39.2216 10.2054 41.6049 12.372 42.9049C13.4554 43.5549 14.5387 43.9882 15.8387 43.9882C16.922 43.9882 17.7887 43.9882 18.6554 43.5549C21.6887 42.4716 23.8554 39.6549 23.8554 36.1882V0.438232H32.3054C32.3054 1.3049 32.3054 2.17157 32.522 2.82157C33.172 6.07157 34.9054 8.88823 37.5054 10.6216C39.672 12.3549 42.4887 13.2216 45.3054 13.2216V21.8882H45.7387Z"
  }));
};
export var TikTokIconGlyph = function (props) {
  return React.createElement(TikTokIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};